import BoardNotice_popup from "../contents/common/board/BoardNotice_popup";
import BoardCheck_popup from "../contents/common/board/BoardCheck_popup";
import BoardModLogList_popup from "../contents/common/board/BoardModLogList_popup";
import UserTelLog_popup from "../contents/manager/org_mng/UserTelLog_popup";

import BdExceptionNotice_popup from "../contents/ptmi/03_exception/BdExceptionNotice_popup";

import Fidelity_popup from "../contents/ptmi/04_fidelity/Fidelity_popup";
import Fidelity_mng_popup from "../contents/ptmi/04_fidelity/Fidelity_mng_popup";

import TrmsV3_popup from "../contents/trms/01_trmsinfo/TrmsV3_popup";
import TrmsV2_popup from "../contents/trms/01_trmsinfo/TrmsV2_popup";
import Intype_popup from "../contents/trms/07_intype_trms/Intype_popup";
import CallArrival_popup from "../contents/trms/08_trtinfo_trms/CallArrival_popup";
import FirstVisit_popup from "../contents/trms/08_trtinfo_trms/FirstVisit_popup";
import MassTrans_popup from "../contents/trms/08_trtinfo_trms/MassTrans_popup";
import FinalCare_popup from "../contents/trms/08_trtinfo_trms/FinalCare_popup";
import Icut_popup from "../contents/trms/08_trtinfo_trms/Icut_popup";
import Incurr_popup from "../contents/trms/06_incurr_trms/Incurr_popup";
import OperRegList_popup from "../contents/trms/10_operrslt_list/OperRegList_popup";
import OperCmit_popup from "../contents/trms/10_operrslt_list/OperCmit_popup";
import ManageCmit_popup from "../contents/trms/10_operrslt_list/ManageCmit_popup";
import CalamityTraing_popup from "../contents/trms/10_operrslt_list/CalamityTraing_popup";
import EdcTraing_popup from "../contents/trms/10_operrslt_list/EdcTraing_popup";
import EcshgHnf_popup from "../contents/trms/10_operrslt_list/EcshgHnf_popup";
import FidelityCommon_popup from "../contents/trms/05_fidelity_trms/FidelityCommon_popup";
import Ptmi_popup from "../contents/trms/05_fidelity_trms/Ptmi_popup";

import OperRegTrnList_popup from "../contents/trms/11_operrslt_trnlist/OperRegTrnList_popup";
import TrnThesis_popup from "../contents/trms/11_operrslt_trnlist/TrnThesis_popup";
import TrnAbst_popup from "../contents/trms/11_operrslt_trnlist/TrnAbst_popup";
import OperCmitTrnList_popup from "../contents/trms/11_operrslt_trnlist/OperCmitTrnList_popup";
import EcshgHnfTrn_popup from "../contents/trms/11_operrslt_trnlist/EcshgHnfTrn_popup";
import TrnNote_popup from "../contents/trms/11_operrslt_trnlist/TrnNote_popup";
import OperRegAftDttbList_popup from "../contents/trms/09_human_resource/OperRegAftDttbList_popup";

import FIleUpload_popup from "../contents/trms/09_human_resource/FileUpload_popup";
import FileUploadNurse_popup from "../contents/trms/09_human_resource/FileUploadNurse_popup";
import FileUploadSpecial_popup from "../contents/trms/09_human_resource/FileUploadSpecial_popup";
import FileUploadSupport_popup from "../contents/trms/09_human_resource/FileUploadSupport_popup";
import FileUploadSNurse_popup from "../contents/trms/09_human_resource/FileUploadSNurse_popup";
import FileUploadEtc_popup from "../contents/trms/09_human_resource/FileUploadEtc_popup";
import FileUploadScheduled_popup from "../contents/trms/09_human_resource/FileUploadScheduled_popup";
import DutySearch_popup from "../contents/trms/09_human_resource/DutySearch_popup";
import ConfirmCancel_popup from "../contents/trms/09_human_resource/ConfirmCancel_popup";
import JunsongDetail_popup from "../contents/ptmi/13_current_trans/JunsongDetail_popup";

const PopupPages = [
    // board
    { path: '/popup/board_notice_popup', titlename: '업무공유 안내 팝업', comp: <BoardNotice_popup /> },
    { path: '/popup/board_check_popup', titlename: '게시글 조회 확인', comp: <BoardCheck_popup /> },
    { path: '/popup/board_mod_list_popup', titlename: '게시글 분류 수정 이력', comp: <BoardModLogList_popup /> },
    { path: '/popup/user_tel_log_popup', titlename: '게시글 분류 수정 이력', comp: <UserTelLog_popup /> },
    //01_ptmiinfo - 표준정보조회

    //02_datacheck - 데이터 검토

    //03_exception - 예외전송관리
    { path: '/nedis/exception/Bdexception_notice_popup.do', titlename: '예외전송신청 안내', comp: <BdExceptionNotice_popup /> },

    //04_fidelity - 충실도 정보관리
    { path: '/nedis/fidelity_2016/send_stat_monthly_popup.do', titlename: '월별전송내역 팝업', comp: <Fidelity_popup /> },
    { path: '/nedis/fidelity_2016/info_mng_stat_monthly_popup.do', titlename: '월별정보관리내역 팝업', comp: <Fidelity_mng_popup /> },

    //05_monitoring - 입력현황 모니터링

    //06_datachecksheet_nedis - 정보전송 점검표(NEDIS)

    //07_datachecksheet - 정보전송 점검표

    //08_patient_statis - 환자규모 및 특성현황 통계

    //09_hosp_bef_statis - 병원전단계 통계

    //10_hosp_aft_statis - 병원단계 통계

    //11_hosp_trans_statis - 병원간 이송단계 통계

    //12_treat_analysis - 진료내역분석

    //13_current_trans - 전송 및 이용현황
    { path: '/nedis/currentTrans/junsongDetail_popup.do', titlename: '전송상세내역 팝업', comp: <JunsongDetail_popup /> },

    //14_KTAS - KTAS

    //trms : 외상
    { path: '/nedis/trmsInfo/trms_naeyeok_V3_popup.do', titlename: '외상환자V3 팝업', comp: <TrmsV3_popup /> },
    { path: '/nedis/trmsInfo/trms_naeyeok_V2_popup.do', titlename: '외상환자V2 팝업', comp: <TrmsV2_popup /> },
    { path: '/nedis/trmsInfo/trms_useTime_popup.do', titlename: '환자 데이터', comp: <Intype_popup /> },
    { path: '/nedis/trmsInfo/trms_callArrival_popup.do', titlename: '환자 데이터', comp: <CallArrival_popup /> },
    { path: '/nedis/trmsInfo/trms_firstVisit_popup.do', titlename: '환자 데이터', comp: <FirstVisit_popup /> },
    { path: '/nedis/trmsInfo/trms_massTrans_popup.do', titlename: '환자 데이터', comp: <MassTrans_popup /> },
    { path: '/nedis/trmsInfo/trms_finalCare_popup.do', titlename: '환자 데이터', comp: <FinalCare_popup /> },
    { path: '/nedis/trmsInfo/trms_ICU_popup.do', titlename: '환자 데이터', comp: <Icut_popup /> },
    { path: '/nedis/trmsInfo/trms_incurr_popup.do', titlename: '차트 데이터', comp: <Incurr_popup /> },
    { path: '/nedis/trmsInfo/trms_operRegList_popup.do', titlename: '등록일정관리', comp: <OperRegList_popup /> },
    { path: '/nedis/trmsInfo/trms_operCmit_popup.do', titlename: '등록일정관리', comp: <OperCmit_popup /> },
    { path: '/nedis/trmsInfo/trms_ManageCmit_popup.do', titlename: '등록일정관리', comp: <ManageCmit_popup /> },
    { path: '/nedis/trmsInfo/trms_Calamity_popup.do', titlename: '등록일정관리', comp: <CalamityTraing_popup /> },
    { path: '/nedis/trmsInfo/trms_EdcTraing_popup.do', titlename: '등록일정관리', comp: <EdcTraing_popup /> },
    { path: '/nedis/trmsInfo/trms_ecshgHnf_popup.do', titlename: '등록일정관리', comp: <EcshgHnf_popup /> },
    { path: '/nedis/trmsInfo/trms_fidelityCommon_popup.do', titlename: '충실도 대상 관리', comp: <FidelityCommon_popup /> },
    { path: '/nedis/ptmiInfo/bdjrnaeyeoDetail_popup.do', titlename: '외상 충실도 정보관리', comp: <Ptmi_popup /> },

    { path: '/nedis/trmsInfo/trms_operRegTrnList_popup.do', titlename: '등록일정관리', comp: <OperRegTrnList_popup /> },
    { path: '/nedis/trmsInfo/trms_trnThesis_popup.do', titlename: '등록일정관리', comp: <TrnThesis_popup /> },
    { path: '/nedis/trmsInfo/trms_trnAbst_popup.do', titlename: '등록일정관리', comp: <TrnAbst_popup /> },
    { path: '/nedis/trmsInfo/trms_cmitTrn_popup.do', titlename: '등록일정관리', comp: <OperCmitTrnList_popup /> },
    { path: '/nedis/trmsInfo/trms_ecshgHnfTrn_popup.do', titlename: '등록일정관리', comp: <EcshgHnfTrn_popup /> },
    { path: '/nedis/trmsInfo/trms_trnNote_popup.do', titlename: '등록일정관리', comp: <TrnNote_popup /> },
    { path: '/nedis/trmsInfo/trms_operRegAftDttbList_popup.do', titlename: '등록일정관리', comp: <OperRegAftDttbList_popup /> },
    { path: '/nedis/trmsInfo/trms_humanResource_popup.do', titlename: '인력관리 팝업창', comp: <FIleUpload_popup /> },
    { path: '/nedis/trmsInfo/trms_humanNurse_popup.do', titlename: '간호사 인력관리 팝업창', comp: <FileUploadNurse_popup /> },
    { path: '/nedis/trmsInfo/trms_humanSpecial_popup.do', titlename: '전문의 인력관리 팝업창', comp: <FileUploadSpecial_popup /> },
    { path: '/nedis/trmsInfo/trms_humanSupport_popup.do', titlename: '보조의 인력관리 팝업창', comp: <FileUploadSupport_popup /> },
    { path: '/nedis/trmsInfo/trms_humanSNurse_popup.do', titlename: '전문간호사 인력관리 팝업창', comp: <FileUploadSNurse_popup /> },
    { path: '/nedis/trmsInfo/trms_humanEtc_popup.do', titlename: '기타 인력관리 팝업창', comp: <FileUploadEtc_popup /> },
    { path: '/nedis/trmsInfo/Schdul_popup.do', titlename: '기타 인력관리 팝업창', comp: <FileUploadScheduled_popup /> },
    { path: '/nedis/trmsInfo/DutySearch_popup.do', titlename: '기타 인력관리 팝업창', comp: <DutySearch_popup /> },
    { path: '/nedis/trmsInfo/Confirm_cancel_popup.do', titlename: '사후 근무표 확정 취소', comp: <ConfirmCancel_popup /> },
]
export default PopupPages;